/* @flow */
import Image from 'components/Image.jsx';
import ImageFilePreviewModal from 'components/ImageFilePreviewModal.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';

import type { FilePreviewerProps } from 'groups/components/FilePreview.jsx';

import './styles/FileImagePreview.scss';

export const FileImagePreview = ({file}: FilePreviewerProps) => { // eslint-disable-line object-curly-spacing
  return (
    <ModalTrigger modal={<ImageFilePreviewModal file={file} />}>
      <Link className="FileImagePreview" eventElementName="FileImagePreview">
        <Image src={file.getUrls().cdn} alt={file.getName()} className="FileImagePreview-image" />
      </Link>
    </ModalTrigger>
  );
};

export default FileImagePreview;



// WEBPACK FOOTER //
// ./src/groups/components/FileImagePreview.jsx